var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-info-circle fa-lg icon-button",attrs:{"title":"Detalhar"},on:{"click":function($event){$event.stopPropagation();return _vm.detalharDespesa()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }